import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService } from '../core/cache.service';
import { ApiService } from '../core/api.service';
import { Mappings } from '../../shared/mapping';
//Model
import { wizardFormEditoriaModel } from "./../../models/document/quoting-submit-model";
import { LanguageService } from "../cms/language.service";
import { CurrencyService } from "../cms/currency.service";
import { AuthService } from '../core/auth.service';
@Injectable()
export class QuotingService {

    constructor(
        public _api: ApiService, 
        public language: LanguageService,
        public currency: CurrencyService,
        public _cache: CacheService,
        private mappings: Mappings,
        private authService: AuthService
    ) {}

    getWizardStampaData(modelType: string, resourceId: number, userId: string, lang: string) {
        let url = this.mappings.Web_Api_Get_Wizard_Stampa_Data.replace('{modelType}', modelType).replace('{resourceId}', resourceId.toString()).replace('{userId}', userId).replace('{lang}', lang);
        let key = url;

        return this._api.get(url);
    }


    getWizardBannerData(modelType: string, resourceId: number, userId: string, lang: string) {
        let url = this.mappings.Web_Api_Get_Wizard_Banner_Data.replace('{modelType}', modelType).replace('{resourceId}', resourceId.toString()).replace('{userId}', userId).replace('{lang}', lang);
        let key = url;

        return this._api.get(url);
    }

    getWizardAdesiviData(modelType: string, resourceId: number, userId: string, lang: string) {
        let url = this.mappings.Web_Api_Get_Wizard_Adesivi_Data.replace('{modelType}', modelType).replace('{resourceId}', resourceId.toString()).replace('{userId}', userId).replace('{lang}', lang);
        let key = url;

        return this._api.get(url);
    }

    getWizardBusteData(modelType: string, resourceId: number, userId: string, lang: string) {
        let url = this.mappings.Web_Api_Get_Wizard_Buste_Data.replace('{modelType}', modelType).replace('{resourceId}', resourceId.toString()).replace('{userId}', userId).replace('{lang}', lang);
        let key = url;

        return this._api.get(url);
    }


    getWizardEtichetteData(modelType: string, resourceId: number, userId: string, lang: string) {
        let url = this.mappings.Web_Api_Get_Wizard_Etichette_Data.replace('{modelType}', modelType).replace('{resourceId}', resourceId.toString()).replace('{userId}', userId).replace('{lang}', lang);
        let key = url;

        return this._api.get(url);
    }

    getWizardCommercialeData(modelType: string, resourceId: number, userId: string, lang: string) {
        let url = this.mappings.Web_Api_Get_Wizard_Commerciale_Data.replace('{modelType}', modelType).replace('{resourceId}', resourceId.toString()).replace('{userId}', userId).replace('{lang}', lang);
        let key = url;

        return this._api.get(url);
    }

    getWizardEditoriaData(modelType: string, resourceId: number, userId: string, lang: string) {
        let url = this.mappings.Web_Api_Get_Wizard_Editoria_Data.replace('{modelType}', modelType).replace('{resourceId}', resourceId.toString()).replace('{userId}', userId).replace('{lang}', lang);
        let key = url;

        return this._api.get(url);
    }

    getWizardDataRequest(modelType: string, resourceId: number, lang: string) {
        let userId: string = this.authService.GetUserId();
        
        let url = this.mappings.Web_Api_Get_Wizard_Data_Address.replace('{modelType}', modelType).replace('{resourceId}', resourceId.toString()).replace('{userId}', userId).replace('{lang}', lang);
        let key = url;

        return this._api.get(url);

    }

    getCalculatedWizard(data: wizardFormEditoriaModel) {

        data.language = this.language.getLongLang();
        data.currency = this.currency.getCurrency();

        return this._api.post(this.mappings.Web_Api_Post_Get_Wizard_Price_Estimation, data)
            .do(result => result)
            .share();
    }
    
    getCalculatedAp(data: wizardFormEditoriaModel) {

        data.language = this.language.getLongLang();
        data.currency = this.currency.getCurrency();
        
        return this._api.post(this.mappings.Web_Api_Post_Get_Ap_Price_Estimation, data)
            .do(result => result)
            .share();
    }

    sendRequestInfo(data: wizardFormEditoriaModel) {

        data.language = this.language.getLongLang();

        return this._api.post(this.mappings.Web_Api_Post_Send_Request_Info_Wizard, data)
            .do(result => result)
            .share();
    }

}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/document/quoting.service.ts